import { Button, ICONS, Icon, ActionInfoBox, P, SimpleModal } from '@sellpy/design-system-react-web'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { DataLayer } from '../../../common/analytics/dataLayer.js'
import { SIZES } from '../../uiComponents/constants.js'
import DAC7Info from './DAC7Info.jsx'

const DAC7 = ({ openModalInfo, setOpenModalInfo, showInfoBox = true, useNewUI }) => {
  const navigate = useNavigate()
  const { t } = useTranslation('balance')

  return (
    <>
      {showInfoBox && (
        <div style={{ marginBottom: useNewUI ? '0' : '16px' }}>
          {useNewUI ? (
            <>
              <ActionInfoBox
                headline={t('myShare:dac7.infoBox.headline')}
                subHeadline={t('myShare:dac7.infoBox.subHeadline')}
                column
                icon={
                  <Icon style={{ fontSize: '32px' }} key={ICONS.PROFILE} name={ICONS.PROFILE} />
                }
                addon={
                  <Button
                    color='white'
                    label={t('myShare:dac7.infoBox.cta')}
                    size='small'
                    variant='filled'
                    onClick={() => {
                      setOpenModalInfo(!openModalInfo)
                      DataLayer.trackDAC7OpenInfo()
                    }}
                    disabled={openModalInfo}
                  />
                }
              />
            </>
          ) : (
            <ActionInfoBox
              headline={t('balanceOverview.dac7.infoBox.headline')}
              addon={
                <>
                  <P design='body3'>{t('balanceOverview.dac7.infoBox.subHeadline')}</P>
                  <ul style={{ marginTop: 0 }}>
                    <li>
                      <P design='body3'>{t('balanceOverview.dac7.infoBox.withdrawFunds')}</P>
                    </li>
                    <li>
                      <P design='body3'>{t('balanceOverview.dac7.infoBox.credits')}</P>
                    </li>
                  </ul>
                  <Button
                    color='white'
                    variant='filled'
                    type='button'
                    size={SIZES.SMALL}
                    label={t('balanceOverview.dac7.openModalInfo.button')}
                    onClick={() => {
                      setOpenModalInfo(!openModalInfo)
                      DataLayer.trackDAC7OpenInfo()
                    }}
                    disabled={openModalInfo}
                  />
                </>
              }
              column={true}
            />
          )}
        </div>
      )}

      <SimpleModal
        isOpen={openModalInfo}
        onClose={() => setOpenModalInfo(false)}
        headline={t('balance:balanceOverview.dac7Modal.headline')}
        bottomCTA={[
          {
            fullWidth: true,
            label: t('balanceOverview.dac7.openModalInfo.startForm'),
            onClick: () => navigate('/profile/dac7')
          }
        ]}
      >
        <DAC7Info />
      </SimpleModal>
    </>
  )
}

export default DAC7
